import styled, { css } from "styled-components";

const Tablist = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    border: ${props => props.theme.midGreyBorder};
    margin-bottom: 4.5rem;
    margin-top: 1.6rem;

    @media only screen and (min-width: ${props => props.theme.desktop}) {
        margin-top: 2.4rem;
    }
`;

const TablistHeader = styled.div`
    background-color: ${props => (!props.emptyItems && props.isBusiness ? props.theme.teal : props.theme.greenDark)};
    ${props => {
        return (
            props.emptyItems &&
            css`
                background-color: ${props.theme.darkerGrey};
            `
        );
    }}
    padding-left: 1.6rem;
    padding-right: 1.6rem;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;

    @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
        padding-left: 2.4rem;
        padding-right: 2.4rem;
    }
`;

const TablistContent = styled.div`
    min-height: 270px;
    display: flex;
    flex-direction: column;
    position: relative;
`;

const TabButton = styled.button`
    color: #ffffff70;
    font-size: 1.4rem;
    font-weight: 700;
    padding: 1.6rem 0;

    > span {
        border-radius: 0.5rem;
        padding: 0.2rem 0.8rem;
        background-color: ${props => props.theme.mintGreen};
        color: ${props => props.theme.darkGreen};
        margin-left: 1.6rem;
    }

    &[aria-selected="true"] {
        color: ${props => props.theme.white};
        position: relative;

        &:after {
            content: "";
            position: absolute;
            border-bottom: 0.2rem solid ${props => (props.isBusiness ? props.theme.iceBlue : props.theme.darkYellow)};
            width: 100%;
            bottom: 0;
            left: 0;
        }

        > span {
            background-color: ${props => (props.isBusiness ? props.theme.iceBlue : props.theme.darkYellow)};
            color: ${props => props.theme.black};
        }
    }

    &:not(:first-child) {
        margin-left: 4.8rem;

        @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
            margin-left: 6.4rem;
        }
    }

    @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
        font-size: 1.8rem;
        padding: 1.6rem;
    }
`;

export { Tablist, TablistHeader, TablistContent, TabButton };
